import { useState } from "react"
const useDomain = (defaultDomain = "homol.portal.pay2b.net") => {
  const [domain] = useState(() => {
    const currentHost = window.location.host
    const isLocalhost =
      currentHost.includes("localhost") || currentHost.includes("127.0.0.1")
    return isLocalhost ? defaultDomain : currentHost
  })
  return domain
}
export default useDomain
